import { useMutation, useQueryClient } from '@tanstack/react-query';
import { profileService } from '../api/profile.service';
import { PROFILE_KEYS } from './queryKeys';
import { useAuthStore } from '@/core/stores/auth.store';

export function useUploadAvatar() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (file: File) => profileService.uploadAvatar(file),
    onSuccess: async () => {
      const freshProfile = await queryClient.fetchQuery({
        queryKey: PROFILE_KEYS.me(),
        queryFn: () => profileService.getProfile().then((r) => r.data),
        staleTime: 0,
      });
      useAuthStore.getState().updateUser({
        name: freshProfile.displayName ?? undefined,
        avatarUrl: freshProfile.avatarUrl ?? undefined,
        color: freshProfile.color,
      });
    },
  });
}
